import React from 'react'

import { getHeaderStyled, IHProps } from './H.styled'

const HStyled = getHeaderStyled('h4', {
  fontSize: 1.125,
  fontWeight: 'normal',
  lineHeight: 1.18,
  letterSpacing: 0.3,
})

export class H4 extends React.PureComponent<
  IHProps & React.HtmlHTMLAttributes<HTMLHeadingElement>
> {
  public render() {
    return <HStyled {...this.props} />
  }
}
